
export const Contents = `query Contents($subjectID: ID, $isPublish: Boolean, $name: String) {
  pContents(
    sort: "sortNum:asc"
    where: {
      subject: { id: $subjectID }
      isPublish: $isPublish
      name_contains: $name
    }
  ) {
    id
    name
    router
    subject {
      id
      name
    }
    trade {
      id
      name
      color
    }
    # 行业标题
    industryTitle
    
    # 行业图标
    industryIcon {
      url
    }
    logoImage {
      url
    }
    p_template {
      code
    }
    indexPageDescription
    productImages1 {
      url
    }
    baseInfoTitle1
    baseInfoDesc1
    baseInfoTitle2
    baseInfoDesc2
  }
}`